import DashboardCard, { EmptyState } from './DashboardCard';
import CardGrid from './CardGrid';
import type { CardColumn } from './cardColumns';
import type { DashboardWeightAlert } from '../../types/dashboard';
import { useDashboardNav, RESIDENT_TAB } from './useDashboardNav';

const columns: CardColumn<DashboardWeightAlert>[] = [
  { dataField: 'fullName', caption: 'Name', sizing: 'fill' },
  {
    dataField: 'alertType',
    caption: 'Alert',
    sortOrder: 'asc',
    cellRender: ({ value, text }) => (
      <span className={`weight-alert-badge ${value === 'Significant Change' ? 'critical' : 'warning'}`}>
        {text}
      </span>
    ),
  },
  {
    dataField: 'percentChange',
    caption: '% Change',
    dataType: 'number',
    customizeText: ({ value }) => {
      const v = value as number | null | undefined;
      return v != null ? `${v > 0 ? '+' : ''}${v.toFixed(1)}%` : '-';
    },
  },
  {
    dataField: 'daysSinceWeighed',
    caption: 'Days Since',
    dataType: 'number',
    customizeText: ({ value }) => (value != null ? `${value as number}d` : '-'),
  },
];

interface Props {
  data: DashboardWeightAlert[];
  draggable?: boolean;
  onDragStart?: (e: React.DragEvent) => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
  onDragEnd?: () => void;
}

export default function WeightAlertsCard({ data, ...dragProps }: Props) {
  const { rowLinkProps } = useDashboardNav();
  return (
    <DashboardCard severity="alert" icon="bi-graph-down-arrow" title="Weight Alerts" count={data.length} {...dragProps}>
      {data.length === 0 ? (
        <EmptyState message="No weight alerts" />
      ) : (
        <CardGrid<DashboardWeightAlert>
          {...rowLinkProps<DashboardWeightAlert>((r) => r.pKey_Patient, RESIDENT_TAB.weightHistory)}
          ariaLabel="Weight Alerts"
          dataSource={data}
          columns={columns}
          keyExpr="pKey_Patient"
        />
      )}
    </DashboardCard>
  );
}
